import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { SelectedOperatorListPage, PaymentPage } from "./components";
import { useTheme } from "context/themeContext";

const BuyOperatorDualView = ({ walletBalance }) => {
  const [isBlurred, setIsBlurred] = useState(false);
  const { colorTheme,countryProperties } = useTheme();

  const handleCompletion = () => {
    setIsBlurred((prev) => !prev);
  };

  const firstPageBlur = isBlurred ? "__blur" : "__white-bg";
  const secondPageBlur = !isBlurred ? "__blur" : "__white-bg";

  return (
    <div>
      
 <Row className="twin-view__wrapper">
      <Col
        lg="6"
        md="6"
        sm="12"
        xs="12"
        className={`twin-view__first column-white ${firstPageBlur} animated slideInLeft`}
      >
        <SelectedOperatorListPage
          walletBalance={walletBalance}
          isCompleted={handleCompletion}
          color={colorTheme}
          countryProperties={countryProperties}
        />
      </Col>
      <Col
        lg="6"
        md="6"
        sm="12"
        xs="12"
        className={`twin-view__second column-white ${secondPageBlur}`}
      >
        <PaymentPage isCompleted={handleCompletion} color={colorTheme}  countryProperties={countryProperties} />
      </Col>
    </Row>
    </div>
   
  );
};

export default BuyOperatorDualView;
